export default {
    name: "dropdown",
    template: '#vue-dropdown',
    data() {
        return {
            isExpand: false,
            currentFilter: null,
        }
    },

    props: {
        filters: Array,
        placeholder: String
    },

    computed: {
        currentFilterName() {
            if (this.currentFilter == null) {
                return this.placeholder
            } else {
                return this.filters.filter(filter => {
                    return filter.term_id == this.currentFilter;
                })[0].name
            }
        }
    },

    methods: {},
}